import {ReportLog} from "../../../../../model/ReportLog";
import {ImportedContactsDialog} from "../../imported-contacts-dialog";

export class CustomerImportDialogWrapper extends ImportedContactsDialog {

    static instance = (log: ReportLog) =>
        ImportedContactsDialog.instanceFactory({
            log: log,
            controller: CustomerImportDialogWrapper,
            template: require('./customer-import-dialog-wrapper.html')
        });


    constructor($mdDialog: angular.material.IDialogService) {
        super($mdDialog);
    }

    protected onContactProfileClick = () => {
        this.closeDialog();
    }

}